import React,{useState,useEffect} from 'react';
import './portfolio.css';
import Isotope from 'isotope-layout';
import portfolios from './portfolioList';
import SinglePortfolio from './SinglePortfolio';

function PortfolioAll() {

    const [isotope, setIsotope] = useState(null);
    const [filterKey, setfilterKey] = useState('All');
    const BUTTONS = [ "All" , "Static", "React", "Typescript"];


    useEffect(() => {
        document.body.scrollTop=0; 
    }, [])

    useEffect(() => {
    setIsotope(
        new Isotope('.filter-container', {
        // filter-container: className of the parent of the isotope elements
        itemSelector: '.filter-item', // filter-item: className of the isotope elements
        layoutMode: 'fitRows', // for horizontal isotope
        })
    );
    }, []);

    useEffect(() => {
        if (isotope) {
            // sanity check
            filterKey === 'All'
            ? isotope.arrange({ filter: "*" })
            : isotope.arrange({ filter: `.${filterKey.toLowerCase()}` });

        }
    }, [isotope, filterKey]);



    return (
        <div className="portfolio portfolioAll">
            <div className="container">

                <div className="portfolio-header-container">
                    <ul>
                        {BUTTONS.map((button) =>(
                           <li className={`button ${filterKey === button ? "active" : ''}`} onClick={() => setfilterKey(button)} key={button}>{button}</li>
                        ))}
                    </ul>

                </div>{/* portfolio header end */}
                

                <div className="filter-container">
                    {portfolios.map(portfolio =>{
                        return <SinglePortfolio key={portfolio.url} content={portfolio} />
                    })}

                </div> {/* filter end */}
            </div>      
     </div>
    )
}

export default PortfolioAll
